<div class="actions">
  <ng-content select="[xAction], button"></ng-content>
</div>
